import { IProductNew } from 'interfaces/product';
import { BehaviorSubject, Observable, of } from 'rxjs';
import * as rxjsOperators from 'rxjs-operators';

import { ICoupon, IExitPopUp } from '../interfaces/IExitPopUp';
import apiService, { ApiService } from './api';

export class ExitPopUpService {
  private exitPopUpProduct$ = new BehaviorSubject<IExitPopUp>(null);
  private selectedProduct$ = new BehaviorSubject<IProductNew>(null);

  constructor(private api: ApiService) {}

  public loadExitPopUpProduct = (productId: number): Observable<IExitPopUp> => {
    return this.api.get(`/exitpopup/${productId}`).pipe(rxjsOperators.tap(data => this.exitPopUpProduct$.next(data)));
  };

  public getExitPopUpProduct = (): Observable<IExitPopUp> => {
    return this.exitPopUpProduct$.asObservable();
  };

  public enableExitPopUp = (exitPopUp: IExitPopUp) => {
    const newExitPopUp = { ...exitPopUp, enabled: !exitPopUp.enabled };

    this.exitPopUpProduct$.next(newExitPopUp);
  };

  public setSelectedProduct(product: IProductNew) {
    this.selectedProduct$.next(product);
    this.loadExitPopUpProduct(product.id).subscribe();
  }

  public changeExitPopUp = (exitPopUp: IExitPopUp) => {
    this.exitPopUpProduct$.next(exitPopUp);
    return of(true);
  };

  public save = (coupon: ICoupon, exitPopUp: IExitPopUp, selectedProduct: IProductNew): Observable<any> => {
    return this.api.put(`/exitpopup/${selectedProduct.id}`, exitPopUp);
  };
}

export const ExitPopUpServiceFactory = () => new ExitPopUpService(apiService);

export const exitPopUpService = ExitPopUpServiceFactory();
